import {LiveMap} from "../../components/LiveMap/LiveMap";
import {ThemedPage} from "@ots-frontend/ots-ui";

export const MapPage = () => {
  return (
    <ThemedPage>
      <LiveMap/>
    </ThemedPage>
  );
};
